import { useFormContext } from 'react-hook-form';
import {
  IntegrationSettingsEntryRequiredStatus,
  IntegrationSettingsForm,
  IntegrationSettingsTypedInputProps,
} from 'modules/integrationSettings/types';
import { NumberFormatField } from 'components/form';

export const IntegerInput = ({ integrationSettingsEntry, dataKey }: IntegrationSettingsTypedInputProps) => {
  const { control } = useFormContext<IntegrationSettingsForm>();

  const required = integrationSettingsEntry.requiredStatus === IntegrationSettingsEntryRequiredStatus.Required;
  return (
    <NumberFormatField
      control={control}
      label={integrationSettingsEntry.displayName}
      rules={{
        required,
      }}
      textFieldProps={{
        required,
      }}
      name={`${integrationSettingsEntry.level}.${dataKey}.integrationSettingsValues.${integrationSettingsEntry.name}`}
    />
  );
};
